/* eslint-disable max-len */
import React from 'react';

const YoutubeIcon = props => (
  <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19" {...props}>
    <path
      fillRule="evenodd"
      d="M9.783 3.126c1.117.006 5.217.049 6.359.357.731.196 1.307.776 1.503 1.512C18 6.33 18 9.114 18 9.114s0 2.784-.355 4.118c-.196.736-.772 1.316-1.503 1.513-1.215.327-5.784.355-6.537.357h-.21c-.753-.002-5.322-.03-6.537-.357-.731-.197-1.307-.777-1.503-1.513-.317-1.191-.35-3.538-.355-4.028v-.181c.004-.49.038-2.836.355-4.028.196-.736.772-1.316 1.503-1.512C4 3.175 8.1 3.132 9.218 3.126zM7.76 6.586v5.055l4.444-2.527L7.76 6.586z"
    />
  </svg>
);

export default YoutubeIcon;
